export const QueryKeyEnum = {
  ANALYSIS_REMARKS: {
    COMMENTS: {
      ALL: 'ANALYSIS_REMARKS_COMMENTS_ALL',
      CREATE: 'ANALYSIS_REMARKS_COMMENTS_CREATE',
    },
    CREATE: 'ANALYSIS_REMARKS_CREATE',
    DETAILS: 'ANALYSIS_REMARKS_DETAILS',
    SEARCH: 'ANALYSIS_REMARKS_SEARCH',
    STATE_UPDATE: 'ANALYSIS_REMARKS_STATE_UPDATE',
  },
  CANDIDATE_CV_DOWNLOAD: 'CANDIDATE_CV_DOWNLOAD',
  CANDIDATE_DETAILS: 'CANDIDATE_DETAILS',
  CANDIDATE_STATUS: 'CANDIDATE_STATUS',
  CANDIDATES_ADDITIONAL_OPTIONS: 'CANDIDATES_ADDITIONAL_OPTIONS',
  CREATE_INTERVIEW_SIMULATIONS: 'CREATE_INTERVIEW_SIMULATIONS',
  CURRENT_USER_DETAILS: 'CURRENT_USER_DETAILS',
  CV_SEARCH: {
    ADD_CANDIDATE_TAG: 'CV_SEARCH_ADD_CANDIDATE_TAG',
    ADD_CANDIDATE_TO_CONTACT_LIST: 'CV_SEARCH_ADD_CANDIDATE_TO_CONTACT_LIST',
    ADD_CANDIDATE_TO_PROCESS: 'CV_SEARCH_ADD_CANDIDATE_TO_PROCESS',
    ALL: 'CV_SEARCH_ALL',
    CANDIDATE_PROFILE: 'CV_SEARCH_CANDIDATE_PROFILE',
    CANDIDATE_TAGS: 'CV_SEARCH_CANDIDATE_TAGS',
    CONTACT_LIST: 'CV_SEARCH_CONTACT_LIST',
    CONTINUE: 'CV_SEARCH_CONTINUE',
    DEFAULT: 'CV_SEARCH_DEFAULT',
    DEFAULT_CLEAR: 'CV_SEARCH_DEFAULT_CLEAR',
    DEFAULT_PROPOSAL: 'CV_SEARCH_DEFAULT_PROPOSAL',
    DEFAULT_RECREATE: 'CV_SEARCH_DEFAULT_RECREATE',
    DEFAULT_SET: 'CV_SEARCH_DEFAULT_SET',
    DETAILS: 'CV_SEARCH_DETAILS',
    INFERRED_TAGS: 'CV_SEARCH_INFERRED_TAGS',
    LANGUAGE_LEVELS: 'CV_SEARCH_LANGUAGE_LEVELS',
    MATCHES: 'CV_SEARCH_MATCHES',
    PRESETS: 'CV_SEARCH_PRESETS',
    PREVIEW: 'CV_SEARCH_PREVIEW',
    PRESETS_CREATE: 'CV_SEARCH_PRESETS_CREATE',
    PRESETS_DELETE: 'CV_SEARCH_PRESETS_DELETE',
    PRESETS_UPDATE: 'CV_SEARCH_PRESETS_UPDATE',
    REMOVE_CANDIDATE_TAG: 'CV_SEARCH_REMOVE_CANDIDATE_TAG',
    REMOVE_FROM_CONTACT_LIST: 'CV_SEARCH_REMOVE_FROM_CONTACT_LIST',
    RESULTS: 'CV_SEARCH_RESULTS',
    RETAG_CANDIDATE: 'CV_SEARCH_RETAG_CANDIDATE',
    REWIND_TO_INFERRED_TAGS: 'CV_SEARCH_REWIND_TO_INFERRED_TAGS',
    RENAME: 'CV_SEARCH_RENAME',
    SYNC_STATUS: 'CV_SEARCH_SYNC_STATUS',
    SYNC_STATUS_RECOMPUTE: 'CV_SEARCH_SYNC_STATUS_RECOMPUTE',
    TAGS: 'CV_SEARCH_TAGS',
    TAGS_CREATE: 'CV_SEARCH_TAGS_CREATE',
    TAGS_DELETE: 'CV_SEARCH_TAGS_DELETE',
    TAGS_MERGE: 'CV_SEARCH_TAGS_MERGE',
    TAGS_SEARCH: 'CV_SEARCH_TAGS_SEARCH',
    TAGS_UPDATE: 'CV_SEARCH_TAGS_UPDATE',
    UPDATE_CONTACT_LIST_STATUS: 'CV_SEARCH_UPDATE_CONTACT_LIST_STATUS',
    UPDATE_CRITERIA: 'CV_SEARCH_UPDATE_CRITERIA',
    UPDATE_JD_KEYWORDS: 'CV_SEARCH_UPDATE_JD_KEYWORDS',
  },
  ENV: 'ENV',
  EXPERIENCE_COMPANIES: {
    ALL: 'EXPERIENCE_COMPANIES',
    CREATE: 'EXPERIENCE_COMPANIES_CREATE',
    DELETE: 'EXPERIENCE_COMPANIES_DELETE',
    UPDATE: 'EXPERIENCE_COMPANIES_UPDATE',
  },
  EXPERIENCE_COMPANY_GROUPS: {
    ALL: 'EXPERIENCE_COMPANY_GROUPS',
  },
  GET_PROCESS_STATUS: 'GET_PROCESS_STATUS',
  INTAKE_CALL_TEMPLATES: {
    ALL: 'INTAKE_CALL_TEMPLATES',
  },
  INTERVIEW_SIMULATIONS: 'INTERVIEW_SIMULATIONS',
  INTERVIEW_SIMULATIONS_DETAILS: 'INTERVIEW_SIMULATIONS_DETAILS',
  INTERVIEW_SIMULATIONS_STATUS: 'INTERVIEW_SIMULATIONS_STATUS',
  LOCATIONS: {
    TAXONOMY: 'LOCATIONS_TAXONOMY',
  },
  MEETINGS: {
    DELIVERIES: 'MEETINGS_DELIVERIES',
    DETAILS: 'MEETINGS_DETAILS',
    DOCUMENT_PDF: 'MEETINGS_DOCUMENT_PDF',
    EVENTS: 'MEETINGS_EVENTS',
    FEEDBACKS: 'MEETINGS_FEEDBACKS',
    NOTE: 'MEETINGS_NOTE',
    NOTE_PARTS: 'MEETINGS_NOTE_PARTS',
    NOTE_PARTS_PREVIEW: 'MEETINGS_NOTE_PARTS_PREVIEW',
    NOTE_PDF: 'MEETINGS_NOTE_PDF',
    ORGANIZERS: 'MEETINGS_ORGANIZERS',
    PROCESS_OPTIONS: 'MEETINGS_PROCESS_OPTIONS',
    SAVE_FEEDBACK: 'MEETINGS_SAVE_FEEDBACK',
    SEARCH: 'MEETINGS_SEARCH',
    SEND_NOTE: 'MEETINGS_SEND_NOTE',
    TRANSCRIPT: 'MEETINGS_TRANSCRIPT',
    UPDATE_NOTE: 'MEETINGS_UPDATE_NOTE',
  },
  PROCESS: {
    CV_UPLOAD: 'PROCESS_CV_UPLOAD',
    DETAILS: 'PROCESS_DETAILS',
    INTAKE_CALL_PROPOSALS: 'PROCESS_INTAKE_CALL_PROPOSALS',
    INTAKE_MEETINGS: 'PROCESS_INTAKE_MEETINGS',
    INTAKE_TEAMS_MEETING: 'PROCESS_INTAKE_TEAMS_MEETING',
    POSSIBLE_STATUSES: 'PROCESS_POSSIBLE_STATUSES',
    SET_ANALYSIS_MODE: 'PROCESS_SET_ANALYSIS_MODE',
    SET_CLOSED: 'PROCESS_SET_HIDDEN',
    SET_DEFINED: 'PROCESS_SET_DEFINED',
    START: 'PROCESS_START',
  },
  PROCESS_CANDIDATES: {
    ALL: 'PROCESS_CANDIDATES_ALL',
    DELETE: 'PROCESS_CANDIDATES_DELETE',
    STATISTICS: 'PROCESS_CANDIDATES_STATISTICS',
  },
  PROCESS_TEMPLATES: {
    ALL: 'PROCESS_TEMPLATES',
    CREATE: 'PROCESS_TEMPLATES_CREATE',
    DELETE: 'PROCESS_TEMPLATES_DELETE',
    UPDATE: 'PROCESS_TEMPLATES_UPDATE',
  },
  PROCESSES: {
    ALL: 'PROCESSES_ALL',
    STATUS_COUNT: 'PROCESSES_STATUS_COUNT',
  },
  USERS: {
    ALL: 'USERS',
    SAVE_TOURS: 'SAVE_TOURS',
    SKIPPED: 'USERS_SKIPPED',
    TOURS: 'USER_TOURS',
  },
} as const;
